<template>
  <div class="objective-modal">
    <div class="modal fade" data-bs-backdrop="static" id="objectiveDeleteModal" tabindex="-1">
      <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable" v-draggable-modal>
        <div v-if="elementType" class="modal-content bg-primary">

          <div class="modal-header">
            <div class="h5 modal-title text-light">
              <span v-if="elementType === 'project'"> {{ $t("views.objective.edit.headingDeleteObjective") }} </span>
              <span v-if="elementType === 'review'"> {{ $t("views.objective.edit.headingDeleteReview") }} </span>
              <span v-if="elementType === 'measure'"> {{ $t("views.objective.edit.headingDeleteMeasure") }} </span>
              <span v-if="elementType === 'conflict'"> {{ $t("views.objective.edit.headingDeleteConflict") }} </span>
              <span v-if="elementType === 'trial'"> {{ $t("views.objective.edit.headingDeleteTrial") }} </span>
            </div>
            <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>

          <div class="modal-body bg-light">
            <div v-if="elementType === 'objective'" class="text-center my-3">
              <p class="fw-bold">{{ this.selectedObjective.name }}</p>
              <p> {{ $t("views.objective.edit.confirmDeleteObjective") }}</p>
              <p> {{ $t("views.objective.edit.infoDelete") }}</p>
            </div>
            <div v-if="elementType === 'review'" class="text-center my-3">
              <p class="fw-bold"> {{ this.objectiveModalElementName }}</p>
              <p> {{ $t("views.objective.edit.confirmDeleteReview") }}</p>
            </div>
            <div v-if="elementType === 'measure'" class="text-center my-3">
              <p class="fw-bold"> {{ this.objectiveModalElementName }}</p>
              <p> {{ $t("views.objective.edit.confirmDeleteMeasure") }}</p>
            </div>
            <div v-if="elementType === 'conflict'" class="text-center my-3">
              <p class="fw-bold"> {{ this.objectiveModalElementName }}</p>
              <p> {{ $t("views.objective.edit.confirmDeleteConflict") }}</p>
            </div>
            <div v-if="elementType === 'trial'" class="text-center my-3">
              <p class="fw-bold"> {{ this.objectiveModalElementName }}</p>
              <p> {{ $t("views.objective.edit.confirmDeleteTrial") }}</p>
            </div>
          </div>

          <div class="modal-footer bg-light">
            <button type="button" class="btn btn-sm btn-outline-secondary" data-bs-dismiss="modal">{{ $t("general.close") }}</button>
            <button @click="deleteElement()" type="button" class="btn btn-sm btn-danger" data-bs-dismiss="modal">{{ $t("general.delete") }}</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ObjectiveDeleteModal',
  mounted () {
    const myModalDialog = document.getElementById('objectiveDeleteModal')

    myModalDialog.addEventListener('shown.bs.modal', event => {
      this.objectiveModalElementName = this.$parent.objectiveModalElementName
    })
  },
  data () {
    return {
      objectiveModalElementName: ''
    }
  },
  computed: {
    selectedObjective () {
      return this.$store.state.selectedObjective
    },
    elementId () {
      return this.$parent.objectiveModalElementId
    },
    elementType () {
      return this.$parent.objectiveModalElementType
    }
  },
  methods: {
    async deleteElement () {
      try {
        this.$store.commit('SET_LOADING_STATUS', true)
        if (this.elementType === 'objective' && !this.selectedObjective.hasNodes) {
          await this.$store.dispatch('deleteObjective', this.selectedObjective.id)
        } else if (this.elementType === 'record') {
          await this.$store.dispatch('deleteObjectiveElement', { objectiveId: this.selectedObjective.id, elementType: 'keyresults/' + this.$parent.objectiveModalKeyResultId + '/records', elementId: this.elementId })
        } else {
          await this.$store.dispatch('deleteObjectiveElement', { objectiveId: this.selectedObjective.id, elementType: (this.elementType + 's'), elementId: this.elementId })
        }
      } finally {
        this.$store.commit('SET_LOADING_STATUS', false)
      }

      // Reload Data & Treeview
      if (this.elementType === 'review' || this.elementType === 'conflict') {
        await this.$store.dispatch('getObjectives', { validFrom: this.$parent.$parent.filterValidFrom, validTo: this.$parent.$parent.filterValidTo, treeView: this.$parent.$parent.objectivesTreeView })
      }
    }
  }
}
</script>
